<template>
  <div>
    <div class="container-fluid p-0 login-width">
      <b-row class="g-0">
        <b-col xl="9" class="d-none d-xl-inline d-lg-inline d-md-inline">
          <div class="auth-full-bg pt-lg-5 p-4">
            <div class="w-100">
              <div class="bg-overlay bg-img"></div>
              <b-row class="d-flex h-100 mt-3" align-h="center" align-content="center" align-v="center">
                <b-col sm="5" class="text-center">
                  <div dir="ltr" class="owl-theme slider-area">
                    <b-carousel
                        id="carousel-1"
                        :interval="5000"
                        indicators
                    >
                      <template v-for="message in clientsMessages">
                        <b-carousel-slide
                            :key="message.id"
                            :img-src="message.img"
                        >
                          <p class="font-size-16 mb-4">
                            <i
                                class="bx bxs-quote-alt-left text-primary h6 align-middle mr-3"
                            ></i>
                            <span v-html="message.message"/>
                            <i
                                class="bx bxs-quote-alt-right text-primary h6 align-middle mr-3"
                            ></i>
                          </p>
                        </b-carousel-slide>
                      </template>
                    </b-carousel>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
        <!-- router-view -->
        <router-view></router-view>

      </b-row>
      <!-- end row -->
    </div>
    <!-- end container-fluid -->
  </div>
</template>
<script>
/**
 * Login component
 */
export default {
  name: "Login",
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: "Login",
      },
    ],
  },
  data() {
    return {
      clientsMessages: [
        {
          'message': this.$t('pages.login.carousel.message_1'),
          'img': require('@/assets/images/login/positive_feedback.svg'),
          'id': 1
        },
        {
          'message': this.$t('pages.login.carousel.message_2'),
          'img': require('@/assets/images/login/email.svg'),
          'id': 2
        },
        {
          'message': this.$t('pages.login.carousel.message_3'),
          'img': require('@/assets/images/login/contact.svg'),
          'id': 3
        }
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  bottom: 1.25rem;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #495057;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}

::v-deep .carousel-item img {
  max-height: 400px !important;
}

.login-width {
  max-width: 100% !important;
}

.bg-img {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(85, 110, 230, 0.3);
  top: 0;
}
</style>